"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* global fetch */

/**
 * Populate the headers value of the init object appropriately. Allows any headers in init to
 * override the provided headers. Mutates init.
 * @param {object} headers a set of headers to be set
 * @param {RequestInit} init the fetch api request init object
 * @return {RequestInit} an updated init object with the headers set appropriately
 */
var addHeadersToInitObject = function addHeadersToInitObject(headers, init) {
  if (init.headers) {
    init.headers = _objectSpread(_objectSpread({}, headers || {}), init.headers);
  } else {
    init.headers = headers;
  }

  return init;
};
/**
 * Reimplementation of the fetch api to permit header injection as well as
 * 401 response handling for McKinsey ID.
 *
 * @param {function (): object} headersHandler a possibly async function that creates headers for
 * sending via fetch
 * @param {function (): void} unauthzHandler a possibly async function that handles any actions required
 * to respond to a 401 unauthorized http response
 * @param {function (): void} logoutHandler logs the user out
 * @return {function(*=, *=): Promise<Response>} a standard fetch api response
 */


var _default = function _default(headersHandler, unauthzHandler, logoutHandler) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(input, init) {
      var overrideInit;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              overrideInit = /*#__PURE__*/function () {
                var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
                  var headers;
                  return _regenerator["default"].wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return headersHandler();

                        case 2:
                          headers = _context.sent;
                          return _context.abrupt("return", !!init ? addHeadersToInitObject(headers, init) : {
                            headers: headers
                          });

                        case 4:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function overrideInit() {
                  return _ref2.apply(this, arguments);
                };
              }();

              _context4.t0 = fetch;
              _context4.t1 = input;
              _context4.next = 5;
              return overrideInit();

            case 5:
              _context4.t2 = _context4.sent;
              return _context4.abrupt("return", (0, _context4.t0)(_context4.t1, _context4.t2).then( /*#__PURE__*/function () {
                var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(res) {
                  return _regenerator["default"].wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          if (!(!res.ok && res.status === 401)) {
                            _context3.next = 13;
                            break;
                          }

                          _context3.next = 3;
                          return unauthzHandler();

                        case 3:
                          _context3.t0 = fetch;
                          _context3.t1 = input;
                          _context3.next = 7;
                          return overrideInit();

                        case 7:
                          _context3.t2 = _context3.sent;
                          _context3.next = 10;
                          return (0, _context3.t0)(_context3.t1, _context3.t2).then( /*#__PURE__*/function () {
                            var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(res) {
                              return _regenerator["default"].wrap(function _callee2$(_context2) {
                                while (1) {
                                  switch (_context2.prev = _context2.next) {
                                    case 0:
                                      if (!(!res.ok && res.status === 401)) {
                                        _context2.next = 5;
                                        break;
                                      }

                                      logoutHandler();
                                      return _context2.abrupt("return", res);

                                    case 5:
                                      return _context2.abrupt("return", res);

                                    case 6:
                                    case "end":
                                      return _context2.stop();
                                  }
                                }
                              }, _callee2);
                            }));

                            return function (_x4) {
                              return _ref4.apply(this, arguments);
                            };
                          }());

                        case 10:
                          return _context3.abrupt("return", _context3.sent);

                        case 13:
                          return _context3.abrupt("return", res);

                        case 14:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }));

                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports["default"] = _default;